import usePage from '../../hooks/usePage';
import { getComponentFromName } from '../../lib/utils';

import { useTheme } from '../../contexts/ThemeContext';
import * as Components from './locations-index';

function LocationsPage() {
    const { page } = usePage();
    const { name = null, variant = null } = useTheme();

    const Component =
        (variant || []).reduce(
            (acc, v) => acc || getComponentFromName(Components, v, null),
            null,
        ) ||
        getComponentFromName(Components, name) ||
        null;

    return Component !== null ? <Component page={page} /> : null;
}

export default LocationsPage;
